import React, {useEffect} from 'react';

import Select from '../adapters/Select';
import {Grid, IconButton, TextField} from '@material-ui/core';
import {Clear} from '@material-ui/icons'
import { logger } from '../../utils/logger';

import Dropzone from 'react-dropzone';
import {useDispatch, useSelector} from "react-redux";
import {loadCAServers, signSelector, setCAServer, setPrivateKeyFile, setPrivateKeyPassword} from '../../redux/sign';


export default function GetSignParams() {

  const dispatch = useDispatch();

  const {caServers, caServer, privateKeyFile, privateKeyPassword} = useSelector(signSelector);

  useEffect(() => {
    console.log('loading CA servers');
    dispatch(loadCAServers());
  }, []);


  const handleChangeCAServer = (event) => {
    logger.debugLog("onCaServerChanged: ", event.target.value);
    const caServer = event.target.value >= 0 ? caServers[event.target.value] : null;
    dispatch(setCAServer(caServer));
  };

  const onClearKeyFileClick = () => {
    dispatch(setPrivateKeyFile(null));
  };

  const onKeyFileDrop = (acceptedFiles, rejectedFiles) => {
    logger.debugLog('onKeyFileDrop called.', acceptedFiles);
    if (!rejectedFiles.length && acceptedFiles.length === 1) {
      dispatch(setPrivateKeyFile(acceptedFiles[0]));
    }
  };

  const getPrivateKeyFileLabel = () => {
    let divStyle = { fontSize: '1.2em' };
    if (privateKeyFile)
      return (<div style={{ ...divStyle, color: '#075b7f' }}>{privateKeyFile.name}</div>);
    else
      return (<div style={divStyle}>Перетягніть або натисніть для завантаження файлу</div>);
  }

  let selectedServerId = caServer && caServer.id;
  if (selectedServerId === undefined || selectedServerId === null)
    selectedServerId = '';

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Select
            label="Центр сертифікації, який видав ключ"
            value={ selectedServerId}
            onChange={handleChangeCAServer}
            content={caServers}
            //isError={!caServer || caServer.id === null || caServer.id === undefined}
            //errorText="Оберіть центр сертифікації, який видав ключ"
          />
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      <Grid container alignItems='flex-end'>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <div className="label">Особистий ключ підпису</div>
            <Dropzone
              onDrop={ (accepted, rejected) => onKeyFileDrop(accepted, rejected)}
            >
              {({getRootProps, getInputProps}) => (
                <section className="dropzone">
                  <div {...getRootProps({multiple: false})}>
                    <input {...getInputProps()} />
                    {getPrivateKeyFileLabel()}
                  </div>
                </section>
              )}
            </Dropzone>
        </Grid>
        <Grid item xs={1}>
          <IconButton onClick={onClearKeyFileClick}>
            <Clear color='primary' />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <TextField
            fullWidth={true}
            variant="outlined"
            type="password"
            label="пароль особистого ключа підпису"
            value={privateKeyPassword ||''}
            //error={!privateKeyPassword}
            //helperText={privateKeyPassword ? null : 'Вкажіть пароль до ключа підпису'}
            onChange={(event) => dispatch(setPrivateKeyPassword(event.target.value))}
          />
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>

    </React.Fragment>)

}